import { BaSeParagraph, BaSeRadio, BaSeSmall2, BaSeTheme } from '@base/react';
import React from 'react';
import { QuizProfileContext } from './context/QuizContext';
import { AlignOptions, ContentOptions } from './quiz-profile-style';

function QuizQuestion({
  question,
  handleSelectOption,
  respostaStep,
  sequenceStep,
}) {
  const { save } = React.useContext(QuizProfileContext);

  return (
    <>
      <ContentOptions>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          {`${question.description}`}
        </BaSeParagraph>

        <AlignOptions sequenceStep={sequenceStep}>
          {question?.options?.map((op) => (
            <BaSeRadio
              name={op.option.description}
              id={op.option.id}
              shape="circle"
              label={op.option.description}
              color={BaSeTheme.colors.institucionais.cinzaSebrae60}
              size="small"
              checked={respostaStep[question.id]?.option.id === op.option.id}
              onChange={() => {
                handleSelectOption(question.id, op.option.id);
              }}
            />
          ))}
        </AlignOptions>
        {save && respostaStep[question.id]?.option.id === undefined && (
          <BaSeSmall2 color={BaSeTheme.colors.feedbackInterface.erro45}>
            Campo obrigatório.
          </BaSeSmall2>
        )}
      </ContentOptions>
    </>
  );
}

export default QuizQuestion;
